// import { QRCodeSVG } from "qrcode.react";
// import React from "react";

// const mmToPx = (mm) => (mm * 96) / 25.4;

// const cardDimensions = {
//     width: mmToPx(84.5),
//     height: mmToPx(53.5),
// };

// const MembershipCardBack = ({ agency, rep }) => {
//     return (
//         <div
//             id={`card-back-${agency.membership_id}-${rep.key}`}
//             style={{ width: cardDimensions.width, height: cardDimensions.height, backgroundColor: "#ffffff", fontFamily: "'Swiss721BT', Arial, sans-serif", borderRadius: "8px", border: "1px solid #ccc", boxSizing: "border-box", display: "flex", flexDirection: "column", overflow: "hidden", }}>
//             <div style={{ backgroundColor: "#bcd4f0", height: "20px", flexShrink: 0 }} />
//             <div
//                 style={{
//                     backgroundColor: "#303381",
//                     padding: "2% 3%",
//                     flexShrink: 0,
//                     fontFamily: "'Swiss721CnBT', Arial, sans-serif",
//                 }}
//             >
//                 <div style={{ fontSize: "0.55rem", lineHeight: "0.75", fontWeight: "600", textAlign: "center", color: "#ffffff", }}>
//                     <span style={{ display: "block", marginBottom: "5px" }}>
//                         This ID card is issued to Members of Travel Agents
//                     </span>
//                     <span style={{ display: "block", marginBottom: "5px" }}>
//                         Association of India. The Tap / Scan of the QR Code
//                     </span>
//                     <span style={{ display: "block" }}>
//                         on this card will determine the member Status
//                     </span>
//                 </div>
//             </div>

//             <div style={{ backgroundColor: "#bcd4f0", flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", }}>
//                 <div style={{ display: "flex", justifyContent: "space-between", width: "90%", marginTop: '10px' }}>
//                     <div style={{ width: "40%", height: "60px", border: "1px solid #ffffff", backgroundColor: 'white' }} />
//                     <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//                         <QRCodeSVG value={`https://taaiapp.emedha.in/offers/${agency.id}`} size={45} />
//                         <div style={{ fontWeight: "bold", fontSize: "0.72rem", }}>OFFERS</div>
//                     </div>
//                     <div style={{ width: "40%", height: "60px", border: "1px solid #ffffff", backgroundColor: 'white' }} />
//                 </div>

//                 <div style={{ marginTop: "4px", fontSize: "0.72rem", fontWeight: "700", color: "#2c2f7a" }}>
//                     TRAVEL AGENTS ASSOCIATION OF INDIA
//                 </div>
//                 <div style={{ fontFamily: "'Swiss721CnBT', Arial, sans-serif", fontSize: "0.5rem", lineHeight: "1.1", textAlign: "center", fontWeight: "600", padding: "2%", flexShrink: 0, marginBottom: '10px' }}>
//                     2-D, Lawrence & Mayo House, 276, Dr. D.N. Road, Fort, Mumbai - 400 001
//                     <br />
//                     Phone: 4083 6786 / 2207 4022 / 8184
//                     Email: taai@taai.in • www.taai.in
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MembershipCardBack;









import Back from "../Images/back.png";
import { QRCodeSVG } from "qrcode.react";
import React from "react";
import TaaiBackImg from "../Images/taaibackimg.png";

const mmToPx = (mm) => (mm * 96) / 25.4;

const cardDimensions = {
    width: mmToPx(84.5),
    height: mmToPx(53.5),
};

const MembershipCardBack = ({ agency, rep }) => {
    return (
        <div id={`card-back-${agency.membership_id}-${rep.key}`} style={{ width: cardDimensions.width, height: cardDimensions.height, borderRadius: "8px", border: "1px solid #ccc", boxSizing: "border-box", display: "flex", flexDirection: "column", overflow: "hidden", backgroundImage: `url(${Back})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", }}>
            {/* Spacer */}
            <div style={{ height: "20px", flexShrink: 0 }} />

            {/* Card description */}
            <div style={{ padding: "2% 3%", flexShrink: 0 }}>
                <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 600, fontSize: "6pt", lineHeight: "0.75", textAlign: "center", color: "#ffffff", marginTop: "-15px", }}>
                    <span style={{ display: "block", marginBottom: "2px" }}>
                        This card is issued to a current member of TAAI and is valid subject
                    </span>
                    <span style={{ display: "block", marginBottom: "2px" }}>
                        to membership renewed. The TAP/Scan of QR Code will determine
                    </span>
                    <span style={{ display: "block", marginBottom: "2px" }}>
                        the member status. Non-Transferable. Issued during 2026 and
                    </span>
                    <span style={{ display: "block", marginBottom: "2px" }}>
                        Property of TAAI.
                    </span>
                </div>
            </div>

            {/* QR code & Offers */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", }}>
                <div style={{ display: "flex", justifyContent: "space-between", width: "90%", marginTop: "10px", }}>
                    <div style={{ width: "40%", height: "60px", border: "1px solid #000000", backgroundColor: "white", }} />
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <QRCodeSVG value={`https://taaiapp.emedha.in/offers/${agency.id}`} size={45} />
                        <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 600, fontSize: "9pt", }}> OFFERS</div>
                    </div>
                    <div style={{ width: "40%", height: "60px", border: "1px solid #000000", backgroundColor: "white", }} />
                </div>

                {/* Footer Image + Address */}
                <div style={{ display: "flex", alignItems: "flex-start", marginTop: "4px", marginBottom: "10px", gap: "10px", padding: "10px", }}>
                    {/* Footer image on left */}
                    <img src={TaaiBackImg} alt="TAAI Footer" style={{ width: "17%", objectFit: "contain" }} />

                    {/* Footer text */}
                    <div style={{ flex: 1 }}>
                        <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: "8pt", color: "#234f7e", marginBottom: "4px", }}>
                            TRAVEL AGENTS ASSOCIATION OF INDIA
                        </div>
                        <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 400, fontSize: "5.2pt", lineHeight: "1.1", textAlign: "left", paddingRight: "4px", }}>
                            <span style={{ display: "block", marginBottom: "2px" }}>
                                2-D, Lawrence & Mayo House, 276, Dr. D.N. Road, Fort, Mumbai - 400 001
                            </span>
                            <span style={{ display: "block" }}>
                                Phone: 4083 6786/2207 4022/8184 • Email: taai@taai.in • www.taai.in
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MembershipCardBack;

